export default "/static/media/c5aa5ea214196a9ce2d7855e5215ed0b.png";